export enum RadioType {
  CIRCLE = 'circle',
  SQUARED = 'squared',
}
